// import logo from './logo.svg';
import { BrowserRouter } from 'react-router-dom';
import './App.css';

import Navegacion from './Router/navegation';
import { SpinnerProvider } from './Component/spinner/spinner';

function App() {
 return (
    <SpinnerProvider>
        <BrowserRouter>
            <Navegacion />
        </BrowserRouter>
    </SpinnerProvider>
 )
}

export default App;
